




















/* eslint-disable class-methods-use-this */
/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import Component from 'vue-class-component';
import BaseComponent from '../BaseComponent';
import axios, { Canceler } from 'axios';

@Component({
  props: {
    label: String,
    options: { default: [] },
    value: {},
  },
})
export default class OrganisationSelect extends BaseComponent {
  label!: string;

  value: any;

  private cancelRequest: Canceler | null = null;

  groups=[];
  // cols!:number;

  // model:any=null;
  get inputValue() {
    return this.value;
  }

  set inputValue(val) {
    this.$emit('input', val);
  }

 getOptionLabel(s:any):string {
    
    return s.display_name;
  }
  mounted(){
    this.getOrganisation("",()=>{});
  }
  getOrganisation(query:string, loading:(monParametre: boolean) => void):void {
    console.log('get orga');
    // Annulez la requête précédente si elle existe
    if (this.cancelRequest) {
      this.cancelRequest();
    }
    // Créez une nouvelle fonction d'annulation pour la nouvelle requête
    const { token, cancel } = axios.CancelToken.source();
    this.cancelRequest = cancel;
    loading(true);
    let url = `${this.contextService.getBaseApiUrl()}usergroup/user-groups/?search=${query}`;
    axios.get(url, {
      cancelToken: token, // Associez le token d'annulation à la requête
    })
      .then((retour:any) => {
        this.groups = retour.data.results;
      }).catch((error) => {
        // Si la requête est annulée alors on ne met pas à jour les adresses
        if (!axios.isCancel(error)) {
          this.groups = [];
        }
      }).finally(() => loading(false));
  }
}
